import { render, staticRenderFns } from "./ReportingUnitDetails.vue?vue&type=template&id=11e77195&scoped=true"
import script from "./ReportingUnitDetails.vue?vue&type=script&lang=js"
export * from "./ReportingUnitDetails.vue?vue&type=script&lang=js"
import style0 from "./ReportingUnitDetails.vue?vue&type=style&index=0&id=11e77195&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e77195",
  null
  
)

export default component.exports